var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShippingPortalSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6071 2.25153C11.9042 2.08656 12.2383 2 12.5781 2C12.9179 2 13.2521 2.08656 13.5491 2.25153L21.0641 6.42553C21.2199 6.51217 21.3497 6.63888 21.4401 6.79255C21.5305 6.94622 21.5781 7.12125 21.5781 7.29953V15.5345C21.5782 15.8913 21.4829 16.2417 21.3019 16.5492C21.121 16.8568 20.8611 17.1103 20.5491 17.2835L13.5491 21.1715C13.2521 21.3365 12.9179 21.4231 12.5781 21.4231C12.2383 21.4231 11.9042 21.3365 11.6071 21.1715L4.60712 17.2825C4.29548 17.1095 4.03576 16.8562 3.85484 16.5491C3.67392 16.2419 3.57839 15.892 3.57813 15.5355V7.29953C3.57812 7.12125 3.62577 6.94622 3.71614 6.79255C3.80651 6.63888 3.93632 6.51217 4.09212 6.42553L11.6071 2.25153Z",
    stroke: "#2F405A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07812 4.21191L17.0781 9.21191V12.7119M6.57812 12.0399L9.57812 13.7119",
    stroke: "#2F405A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57812 6.71191L12.5781 11.7119M12.5781 11.7119L21.5781 6.71191M12.5781 11.7119V21.2119",
    stroke: "#2F405A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingPortalSvg);
export default __webpack_public_path__ + "static/media/shippingPortal_svg.872d079eb57661d3b013c95f31a6daae.svg";
export { ForwardRef as ReactComponent };